<template>
  <TabelaOSD
    :colunas="resolvedColumns"
    :linhas="table.rows"
    :carregando="table.isLoading"
    :total-linhas="table.totalRows"
    :pagina="pagination.page"
    :campo-ordenacao="pagination.sort"
    :ordem-ordenacao="pagination.order"
    :texto-tabela-vazia="$t('indicadoresNaoEncontrados')"
    @page-change="onPageChange"
    @sort-change="onSortChange"
    @reload="getAdmin"
  >
    <template #toolbar-actions>
      <ExPagantesExport v-bind="pagination" :headers="headers" />
    </template>
    <template #toolbar-filters>
      <ExPagantesFilters :loading="table.isLoading" @filter="onFilter" />
    </template>
  </TabelaOSD>
</template>

<script>
import ExPagantesExport from './ExPagantesExport.vue';
import ExPagantesFilters from './ExPagantesFilters.vue';
import TabelaOSD from '@/modules/shared/components/tabelaOSD/TabelaOSD.vue';
import { getPaginatedExPagantesData } from '../exPagantesService';
import { useToast } from 'vue-toastification';
import { toDate } from '@/modules/core/utils/formats';
import { i18n } from '@/modules/localization';
import { ref, computed } from 'vue';

export default {
  components: { ExPagantesExport, ExPagantesFilters, TabelaOSD },
  data: () => ({
    table: {
      totalRows: 0,
      rows: [],
      columns: ref([
        {
          label: computed((_) => i18n.global.t('empresa')),
          field: 'empresa',
        },
        {
          label: computed((_) => i18n.global.t('celular')),
          field: 'celular',
        }, {
          label: computed((_) => i18n.global.t('dataCadastro')),
          field: 'dataCadastro',
          tdClass: 'text-break',
          formatFn: toDate,
        },
        {
          label: computed((_) => i18n.global.t('tipoDaAssinatura')),
          field: 'tipoAssinatura',
        },
        {
          label: computed((_) => i18n.global.t('dataHoraExpiracao')),
          field: 'expiradaEm',
          tdClass: 'text-break',
          formatFn: toDate,
        },
        {
          label: computed((_) => i18n.global.t('ultimaRenovacao')),
          field: 'ultimaRenovacao',
          tdClass: 'text-break',
          formatFn: toDate,
        },
        {
          label: computed((_) => i18n.global.t('plataforma')),
          field: 'plataforma',
        },

      ]),
      mode: 'remote',
      class: 'osd-table',
      styleClass: 'vgt-table bordered condensed',
      compactMode: true,
      lineNumbers: true,
      paginationOptions: {
        enabled: true,
        mode: 'pages',
        perPageDropdownEnabled: false,
        nextLabel: '>',
        prevLabel: '<',
        infoFn: (params) => `
      ${params.firstRecordOnPage} - ${params.lastRecordOnPage} de ${params.totalRecords}
    `,
      },
      sortOptions: {
        enabled: true,
        initialSortBy: { field: 'ultimaRenovacao', type: 'desc' },
      },
      isLoading: false,
    },
    pagination: {
      page: 1,
      sort: 'ultimaRenovacao',
      order: 'desc',
      search: '',
    },
  }),
  computed: {
    resolvedColumns() {
      return this.table.columns.map((column) => ({
        ...column,
        label: column.label?.value ?? column.label,
      }));
    },
    headers() { return this.resolvedColumns.map((column) => column.label); },
  },
  methods: {
    updateParams(pagination) {
      this.pagination = { ...this.pagination, ...pagination };
    },
    onPageChange(page) {
      this.updateParams({ page });
      this.getAdmin();
    },
    onSortChange(field) {
      const nextOrder = this.pagination.sort === field && this.pagination.order === 'asc' ? 'desc' : 'asc';
      this.updateParams({
        page: 1,
        sort: field,
        order: nextOrder,
      });
      this.getAdmin();
    },
    onFilter(filters) {
      this.updateParams({ ...filters, page: 1 });
      this.getAdmin();
    },
    async getAdmin() {
      this.table.isLoading = true;
      try {
        const data = await getPaginatedExPagantesData(this.pagination);
        this.table.rows = data.dados;
        this.table.totalRows = data.total;
      } catch (error) {
        useToast().error(ref(computed((_) => i18n.global.t('erroAoObterAsInfos'))));
      }
      this.table.isLoading = false;
    },
  },
};

</script>
